import { render, staticRenderFns } from "./Activate.vue?vue&type=template&id=29edbb2e&scoped=true"
import script from "./Activate.vue?vue&type=script&lang=js"
export * from "./Activate.vue?vue&type=script&lang=js"
import style0 from "./Activate.vue?vue&type=style&index=0&id=29edbb2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29edbb2e",
  null
  
)

export default component.exports